import { useId, useRef } from "react";

/**
 * Editorial floating-label field.
 * - `type` supports text | email | tel | textarea | select
 * - `options` used for select
 */
export default function Field({
  label,
  value,
  onChange,
  type = "text",
  required = false,
  placeholder,
  options,
  error,
  autoComplete,
  testId,
  maxLength,
}) {
  const inputRef = useRef(null);
  const id = useId();
  const filled = value !== undefined && value !== null && String(value).length > 0;

  const commonProps = {
    id,
    ref: inputRef,
    value: value ?? "",
    onChange: (e) => onChange(e.target.value),
    required,
    placeholder: placeholder || "",
    autoComplete,
    "data-testid": testId,
  };

  return (
    <label
      htmlFor={id}
      className={`field block w-full ${filled ? "filled" : ""} ${
        error ? "border-red-500" : ""
      }`}
    >
      <span>
        {label}
        {required ? <span className="text-[color:var(--sbh-terracotta)]"> *</span> : null}
      </span>
      {type === "textarea" ? (
        <textarea rows={3} maxLength={maxLength} {...commonProps} />
      ) : type === "select" ? (
        <select {...commonProps}>
          <option value="" disabled hidden>
            {placeholder || "Select…"}
          </option>
          {options?.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      ) : (
        <input type={type} maxLength={maxLength} {...commonProps} />
      )}
      {error ? (
        <span className="block mt-1 text-xs text-[color:var(--sbh-terracotta)]">{error}</span>
      ) : null}
    </label>
  );
}
